import { getAccessToken } from '../utils/access-token-storage';
import http from './http';
import socket from './socket';

/* Actions */

const createAccessToken = (data, headers) => http.post('/access-tokens', data, headers);

const deleteCurrentAccessToken = (headers) => socket.delete('/access-tokens/me', undefined, headers);

const withAuthHeaders = (headers) => {
  const accessToken = getAccessToken();

  return {
    ...headers,
    ...(accessToken && {
      Authorization: `Bearer ${accessToken}`,
    }),
  };
};

/* Personal Access Tokens (PATs) - managed via authenticated socket transport
 * because the http transport is POST/GET-only with FormData encoding, which
 * cannot carry the scopes array. */

const listPersonalAccessTokens = (headers) => socket.get('/access-tokens', undefined, withAuthHeaders(headers));

const createPersonalAccessToken = (data, headers) => socket.post('/access-tokens/personal', data, withAuthHeaders(headers));

const updatePersonalAccessToken = (id, data, headers) => socket.patch(`/access-tokens/${id}`, data, withAuthHeaders(headers));

const deletePersonalAccessToken = (id, headers) => socket.delete(`/access-tokens/${id}`, undefined, withAuthHeaders(headers));

export default {
  createAccessToken,
  deleteCurrentAccessToken,
  listPersonalAccessTokens,
  createPersonalAccessToken,
  updatePersonalAccessToken,
  deletePersonalAccessToken,
};
